import React from 'react'

export function Instruments() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.02 2.25996C11.3184 2.08929 11.6562 1.99951 12 1.99951C12.3438 1.99951 12.6816 2.08929 12.98 2.25996L19.98 6.25696C20.61 6.61696 21 7.29296 21 8.02696V15.974C21 16.707 20.61 17.384 19.98 17.743L12.98 21.739C12.6816 21.9096 12.3438 21.9994 12 21.9994C11.6562 21.9994 11.3184 21.9096 11.02 21.739L4.02001 17.743C3.70906 17.564 3.45094 17.3061 3.27181 16.9952C3.09269 16.6844 2.99892 16.3317 3.00001 15.973V8.02696C3.00001 7.29396 3.39001 6.61696 4.02001 6.25796L11.02 2.26196V2.25996ZM12 4.02996L5.00001 8.02596V15.974L12 19.97L19 15.974V8.02596L12 4.02996ZM8.00001 12C8.00001 9.75796 9.79001 7.93996 12 7.93996C14.21 7.93996 16 9.75796 16 12C16 14.242 14.21 16.06 12 16.06C9.79001 16.06 8.00001 14.242 8.00001 12ZM12 9.96996C10.895 9.96996 10 10.879 10 12C10 13.121 10.895 14.03 12 14.03C13.105 14.03 14 13.121 14 12C14 10.879 13.105 9.96996 12 9.96996Z"
        fill="#292E3D"
      />
    </svg>
  )
}
